module.exports = __webpack_public_path__ + "static/media/atlantix-zen-footer.358e152c.jpg";